<template>
  <div v-if="items">
    <v-card>
      <v-card-title
        ><h4>{{ title }}</h4></v-card-title
      >
      <v-divider></v-divider>
      <v-list dense>
        <v-list-item
          :class="`${getColor(item, reference[index])}`"
          v-for="(item, index) of items"
          :key="item.name"
        >
          <v-list-item-content>{{ item.name }}</v-list-item-content>
          <v-list-item-content class="align-end justify-end">{{
            item.value
          }}</v-list-item-content>
        </v-list-item>
      </v-list>
    </v-card>
  </div>
</template>
<script>
export default {
  name: 'exo-constellation-optimizer-table',
  props: {
    items: Array,
    reference: Array,
    title: String,
    optimized: Boolean
  },

  methods: {
    getColor(item, reference) {
      if (
        item != undefined &&
        reference != undefined &&
        item.name == reference.name
      ) {
        if (
          item.value === reference.value ||
          item.value === '' ||
          reference.value === ''
        ) {
          return ''
        } else if (this.optimized) {
          return 'green--text'
        } else {
          return 'red--text'
        }
      }
    }
  }
}
</script>
